import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { Outlet, useLoaderData } from 'react-router'

import { attemptAuth, AuthProvider, AuthState, muiTheme, UiProvider } from '@rdm/shared-ui'

import { API_URL, ENVIRONMENT, UQRDM_SSO_COOKIE_REFRESH_NAME } from './lib/config'

export async function loader(): Promise<AuthState | null> {
  const authState = await attemptAuth(API_URL, UQRDM_SSO_COOKIE_REFRESH_NAME)

  return authState
}

export const Root = () => {
  const authState = useLoaderData() as AuthState | null

  return (
    <ThemeProvider theme={muiTheme}>
      {/* Only production should be discoverable by search engines; keep every other
          environment out of the index. (The April Fools page is noindex everywhere.) */}
      {ENVIRONMENT !== 'production' && <meta name="robots" content="noindex, nofollow" />}
      <CssBaseline />
      <UiProvider>
        <AuthProvider initialAuthState={authState}>
          <Outlet />
        </AuthProvider>
      </UiProvider>
    </ThemeProvider>
  )
}
